import axios from '../axios-default';
import * as React from 'react';
import { withRouter } from 'react-router-dom';

class ThirdPartyLogin extends React.Component {
    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        const search = this.props.location.search;
        const token = new URLSearchParams(search).get('token');
        const redirecturl = new URLSearchParams(search).get('redirecturl');
        let { data } = await axios.post('thirdparty/portal_login', { token });

        const date = new Date().getTime() + 604800000;
        localStorage.setItem('auth-token', JSON.stringify(`${data.user.user_id}`));
        localStorage.setItem('role', JSON.stringify(`${data.user.role}`));
        localStorage.setItem('country_id', JSON.stringify(`${data.user.country_id}`));
        localStorage.setItem('distr_group_id', JSON.stringify(`${data.user.distr_group_id}`));
        localStorage.setItem('admin_group_id', JSON.stringify(`${data.user.admin_group_id}`));
        localStorage.setItem('doctor_dist_id', JSON.stringify(`${data.user.doctor_distr_group_id}`));
        localStorage.setItem('expirationDate', date);
        if (redirecturl) {
            window.location.replace(redirecturl);
        } else {
            window.location.replace('/');
        }
        localStorage.removeItem('Patients.pageNo');
        localStorage.removeItem('Patients.searchStr');
        localStorage.removeItem('Patients.mode');
    }

    render() {
        return '';
    }
}

export default withRouter(ThirdPartyLogin);
